import { Box } from "@mui/material";
import { ReactNode } from "react";
import AnswerDto from "types/AnswerDto";

function getSelectedAnswerValues({ answers }: AnswerDto): string[] {
  if (answers && answers.length > 0) {
    return answers.map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

export default function getAnswer(
  answer?: AnswerDto,
  possibleAnswers?: string[],
): ReactNode {
  if (answer == undefined) return undefined;

  const selected = getSelectedAnswerValues(answer);

  return (
    <Box component="span">
      {possibleAnswers &&
      possibleAnswers[0] !== "" && // TODO: possibleAnswers should not come down as ['']
      possibleAnswers[0] !== "[]" && // TODO: possibleAnswers should not come down as ['[]']
      possibleAnswers.length > 0
        ? possibleAnswers.map((option) => (
            <span
              key={option}
              style={{
                display: "inline-block",
                marginRight: ".5rem",
                marginTop: ".25rem",
                ...(selected.includes(option)
                  ? {
                      padding: ".25rem .5rem",
                      fontWeight: "bold",
                      border: ".125rem solid green",
                      borderRadius: ".5rem",
                    }
                  : {
                      padding: ".25rem 0",
                      textDecoration: "line-through",
                    }),
              }}
            >
              {option}
            </span>
          ))
        : selected.join(", ")}
    </Box>
  );
}
